function CharacterCounter(props: { current: number; max: number; modifier?: string; showWarning?: boolean }) {
    const isOverLimit = props.current > props.max
    const isNearLimit = !isOverLimit && props.current > props.max * 0.9
    const color = isOverLimit && props.showWarning ? 'red' : isNearLimit ? '#d98c00' : 'inherit'

    return (
        <p className={`character-counter character-counter--${props.modifier}`} style={{ color }}>
            {props.current > 0 && (
               <>
                   {`${props.current}/${props.max}`}
                   {props.showWarning && isOverLimit && ` Der Inhalt überschreitet die zulässige Anzahl von ${props.max} Zeichen.`}
               </>
            )}
        </p>
    );
}

export default CharacterCounter
